'use client';

import MarkdownText from '@/components/MarkdownText';

const BlogContent = ({ children }) => {
  return <MarkdownText>{children}</MarkdownText>;
};

export default BlogContent;
